
import BaseFirebaseRepository from '../../../components/repository/BaseFirebaseRepository';

const instances = {}
const defaultInstanceKey = Math.random()
export default class MembershipBenefitRepository extends BaseFirebaseRepository {
    // Indicate that this repository use API instead of Firebase
    isUseAPI = true

    /**
     * @param {*} app
     * @return {MembershipBenefitRepository}
     */
    static getInstance(app) {
        if (app == null) {
            // By default, use instance created from main App
            app = MembershipBenefitRepository.context || defaultInstanceKey
        }
        if (app != null && instances[app] == null) {
            // Create a new instance
            instances[app] = new MembershipBenefitRepository(app)
        }
        return instances[app]
    }
    getRef = () => {
        return null
    }
    getSingleRef = () => {
        // This repository uses API to load instead of Firebase, so this
        // function is not called
        return null
    }
    getBaseObject = () => {
        return {}
    }
    getApiBaseUrl = (id) => {
        if (!id || id == 'all') {
            return `/merchant/api/membership/benefits`
        }
        else {
            return `/merchant/api/membership/benefits/%id%`.replace('%id%', id)
        }
    }
    getReloadEventKey = () => {
        return "membership_benefits_version.changed"
    }

    /**
     * Once we get the result from Firebase, will use this to preprocess the
     * data before pass assign the data to getBaseObject()
     */
     preprocessItem = (rawFirebaseData) => {
        return rawFirebaseData
    }

    /**
     * Parse raw API response before perform any logic
     * @returns {Object}
     */
    parseRawApiResponse = (rawResponse) => {
        if (rawResponse) {
            if (!Array.isArray(rawResponse)) {
                return [rawResponse]
            }
            else {
                return rawResponse
            }
        }
        return []
    }
}
